module.exports = __webpack_public_path__ + "static/media/bd_ttl_daily.bb3787f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bd_ttl_daily.png
// module id = 1623
// module chunks = 1